import { Button, Card, Col, message, Modal, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import AuthService from "../../Services/AuthService";
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { HSdecrypt } from "../../utils/encryptPassword";

function LabReport(props) {
  const [labData, setLabData] = useState([]);
  const [reportView, setReportView] = useState(false);
  const filterValues = props.filterValues;
  const [isLoading, setIsLoading] = useState(false);
  const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  useEffect(() => {
    labReport();
  }, [filterValues, props?.selectedPatient]);

  const labReport = (page, size) => {
    setIsLoading(true);
    if (filterValues) {
      if (filterValues.fromDate) {
        filterValues.fromDate = dayjs(
          filterValues.fromDate,
          "MM/DD/YYYY"
        ).format("MM/DD/YYYY");
      }
      if (filterValues.toDate) {
        filterValues.toDate = dayjs(filterValues.toDate, "MM/DD/YYYY").format(
          "MM/DD/YYYY"
        );
      }
    }
    let payload = {
      status: 1,
      patientId: props?.selectedPatient,
    };
    if (filterValues) {
      if (filterValues.fromDate) {
        payload.fromDate = filterValues.fromDate;
      }
      if (filterValues.toDate) {
        payload.toDate = filterValues.toDate;
      }
      if (filterValues.labTestOrderId) {
        payload.labTestOrderId = filterValues.labTestOrderId;
      }
    }
    AuthService.getHSLabReport(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setLabData(JSON.parse(decryptedData));
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const handleReportView = (record) => {
    const url = record?.resultDocumentName;

    if (!url) {
      message.error("Document not available");
      return;
    }
    if (url.startsWith("http://") || url.startsWith("https://")) {
      window.open(url, "_blank");
      return;
    } else {
      setReportView(record.resultDocumentName);
    }
  };
  return (
    <div>
      <Row gutter={24} className="p-4">
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
              width: "100%",
            }}
          >
            <Spin indicator={loadingIcon} size="large" />
          </div>
        ) : labData.length > 0 ? (
          labData.map((user, i) => (
            <Col xs={24} sm={24} md={12}>
              <div className="border shadow-lg p-4 my-2 rounded-lg bg-white flex flex-col gap-2">
                <div className="grid grid-cols-3 sm:grid-cols-1 gap-4 items-start">
                  <div className="flex flex-col gap-1">
                    <label className="font-bold tஃஃext-black">
                      Date & Time
                    </label>
                    <p className="text-gray-600">{user?.uploadedDateTime}</p>
                  </div>

                  <div className="flex flex-col gap-1 text-center sm:items-start">
                    <label className="font-bold text-black">Lab OrderId</label>
                    <p className="text-gray-600">{user?.labTestOrderId}</p>
                  </div>

                  <div className="flex flex-col gap-1 text-right sm:items-start">
                    <label className="font-bold text-black">
                      Lab Test Name
                    </label>
                    <p className="text-gray-600">{user?.labTestName}</p>
                  </div>
                </div>

                <div className="flex justify-between items-center mt-2">
                  <div>
                    <label className="font-bold text-black">
                      Diagnostics Name
                    </label>
                    <p className="text-gray-600">{user?.labName}</p>
                  </div>

                  <button
                    onClick={() => handleReportView(user)}
                    className="px-3 py-1.5 rounded-md bg-[#189FAA] disabled:bg-slate-500 disabled:cursor-not-allowed text-white text-sm hover:bg-opacity-90 transition-colors cursor-pointer"
                    disabled={!user?.resultDocumentName}
                  >
                    View Report
                  </button>
                </div>
              </div>
            </Col>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              padding: "20px",
              borderRadius: "8px",
              color: "#595959",
              height: "200px",
              textAlign: "center",
              width: "100%",
            }}
          >
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>
              No reports found
            </p>
          </div>
        )}
      </Row>

      {reportView && (
        <Modal
          visible={reportView}
          onOk={() => {
            setReportView(false);
          }}
          centered={true}
          footer={null}
          onCancel={() => {
            setReportView(false);
          }}
          okText="Submit"
          cancelText="Cancel"
          maskClosable={true}
          width={850}
        >
          <embed
            src={process.env.REACT_APP_IMAGE_URL + reportView}
            type="application/pdf"
            width="100%"
            height="550px"
          />
        </Modal>
      )}
    </div>
  );
}
export default LabReport;
